import { computed, shallowRef, type ComputedRef } from 'vue';

export type UseBoolean = {
  value: ComputedRef<boolean>;
  setTrue: () => void;
  setFalse: () => void;
  toggle: () => void;
};

export function useBoolean(initial = false): UseBoolean {
  const state = shallowRef<boolean>(initial);
  const value = computed(() => state.value);

  const setTrue = () => {
    state.value = true;
  };

  const setFalse = () => {
    state.value = false;
  };

  const toggle = () => {
    state.value = !state.value;
  };

  return {
    value,
    setTrue,
    setFalse,
    toggle
  };
}
